export const theftRecoverySupport = `
Hello,

I need support with enabling Theft Recovery on my vehicle: $VIN.

Could you please help with this?
`;
export const unpairedLocatorSupport = `
Hello,

I tried to enable Theft Recovery and received a message that the locator is not paired to my vehicle: $VIN.

Could you please help with this?
`;